<template>
  <section
    :v-bind="$attrs"
    class="eds-card"
    :class="[cardClass]"
    :style="[cardStyle]"
  >
    <header
      v-if="$slots.header"
      class="card-header"
      :class="[headerClass]"
      :style="[headerStyle]"
    >
      <slot name="header" />
    </header>
    <div class="card-content" :class="[bodyClass]" :style="[bodyStyle]">
      <slot name="body" />
    </div>
    <footer
      v-if="$slots.footer"
      class="card-footer"
      :class="[footerClass]"
      :style="[footerStyle]"
    >
      <slot name="footer" />
    </footer>
  </section>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Card',
    props: {
      cardClass: {
        type: String,
        required: false,
        default: '',
      },
      cardStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      heading: {
        type: String,
        required: false,
        default: 'Title',
      },
      footer: {
        type: String,
        required: false,
        default: 'Footer',
      },
      color: {
        type: String,
        required: false,
        default: 'primary',
        validator(value: string) {
          return ['primary', 'basic', 'tertiary', 'danger'].includes(value);
        },
      },
      headerClass: {
        type: String,
        required: false,
        default: '',
      },
      headerStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      bodyClass: {
        type: String,
        required: false,
        default: '',
      },
      bodyStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      footerClass: {
        type: String,
        required: false,
        default: '',
      },
      footerStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>

<style></style>
